<template>
  <div>
    <d-field label="Filemaker Project Number" message="Leave empty to create a new record, or add an ID to update the record">
      <d-input v-model="computedProject.number" />
    </d-field>
    <d-field label="Project Name">
      <d-input v-model="computedProject.name" />
    </d-field>
    <d-field label="Status at Registration">
      <d-select v-model="computedProject.statusAtRegistration" expanded>
        <option value="Architectural Design">
          Architectural Design
        </option>
        <option value="Construction (Not Woodwork)">
          Construction (Not Woodwork)
        </option>
        <option value="Bidding (Woodwork)">
          Bidding (Woodwork)
        </option>
        <option value="Pre-fabrication (Woodwork)">
          Pre-fabrication (Woodwork)
        </option>
        <option value="Shop Drawings (Woodwork)">
          Shop Drawings (Woodwork)
        </option>
        <option value="Fabrication (Woodwork)">
          Fabrication (Woodwork)
        </option>
        <option value="Installation [Woodwork]">
          Installation (Woodwork)
        </option>
      </d-select>
    </d-field>
    <d-field label="Project Type">
      <d-select v-model="computedProject.type" expanded>
        <option :value="null" disabled>
          Select a Type
        </option>
        <option value="Residential/1&2 Family/Customer Home">
          Residential/1&2 Family/Customer Home
        </option>
        <option value="Residential/1&2 Family/Sale-Spec Home">
          Residential/1&2 Family/Sale-Spec Home
        </option>
        <option value="Residential/Apartment-Condo/1-3 Story">
          Residential/Apartment-Condo/1-3 Story
        </option>
        <option value="Residential/Apartment-Condo/4+ Story">
          Residential/Apartment-Condo/4+ Story
        </option>
        <option value="Residential/Elderly-Assisted Living">
          Residential/Elderly-Assisted Living
        </option>
        <option value="Non-Res/Commercial/Office">
          Non-Res/Commercial/Office
        </option>
        <option value="Non-Res/Commercial/Bank">
          Non-Res/Commercial/Bank
        </option>
        <option value="Non-Res/Commercial/Food - Beverage">
          Non-Res/Commercial/Food - Beverage
        </option>
        <option value="Non-Res/Commercial/Grocery">
          Non-Res/Commercial/Grocery
        </option>
        <option value="Non-Res/Commercial/Retail">
          Non-Res/Commercial/Retail
        </option>
        <option value="Non-Res/Commercial/Shopping Center-Strip">
          Non-Res/Commercial/Shopping Center-Strip
        </option>
        <option value="Non-Res/Commercial/Regional Mall">
          Non-Res/Commercial/Regional Mall
        </option>
        <option value="Non-Res/Transport/Airline Terminal">
          Non-Res/Transport/Airline Terminal
        </option>
        <option value="Non-Res/Transport/Passenger Terminal">
          Non-Res/Transport/Passenger Terminal
        </option>
        <option value="Non-Res/Transport/Aircraft Sales-Svc.">
          Non-Res/Transport/Aircraft Sales-Svc.
        </option>
        <option value="Non-Res/Transport/Vehicle Sales-Svc.">
          Non-Res/Transport/Vehicle Sales-Svc.
        </option>
        <option value="Non-Res/Transport/Parking Garage">
          Non-Res/Transport/Parking Garage
        </option>
        <option value="Non-Res/Industrial/Gas-Chemical Plant">
          Non-Res/Industrial/Gas-Chemical Plant
        </option>
        <option value="Non-Res/Industrial/Refinery">
          Non-Res/Industrial/Refinery
        </option>
        <option value="Non-Res/Industrial/Warehouse">
          Non-Res/Industrial/Warehouse
        </option>
        <option value="Non-Res/Industrial/Warehouse (Refrigrt'd)">
          Non-Res/Industrial/Warehouse (Refrigrt'd)
        </option>
        <option value="Non-Res/Industrial/Manufacturing Bldg.">
          Non-Res/Industrial/Manufacturing Bldg.
        </option>
        <option value="Non-Res/Industrial/Freight Terminal">
          Non-Res/Industrial/Freight Terminal
        </option>
        <option value="Non-Res/Education/Library">
          Non-Res/Education/Library
        </option>
        <option value="Non-Res/Education/Primary School">
          Non-Res/Education/Primary School
        </option>
        <option value="Non-Res/Education/Middle-Senior HS">
          Non-Res/Education/Middle-Senior HS
        </option>
        <option value="Non-Res/Education/College-University">
          Non-Res/Education/College-University
        </option>
        <option value="Non-Res/Education/Vocational School">
          Non-Res/Education/Vocational School
        </option>
        <option value="Non-Res/Education/Misc. Edu. Building">
          Non-Res/Education/Misc. Edu. Building
        </option>
        <option value="Non-Res/Education/Kindergarten">
          Non-Res/Education/Kindergarten
        </option>
        <option value="Non-Res/Education/Pre-School">
          Non-Res/Education/Pre-School
        </option>
        <option value="Non-Res/Recreation/Casino">
          Non-Res/Recreation/Casino
        </option>
        <option value="Non-Res/Recreation/Theater-Auditorium">
          Non-Res/Recreation/Theater-Auditorium
        </option>
        <option value="Non-Res/Recreation/Stadium">
          Non-Res/Recreation/Stadium
        </option>
        <option value="Non-Res/Recreation/Museum">
          Non-Res/Recreation/Museum
        </option>
        <option value="Non-Res/Recreation/Convention-Exhibit Ctr">
          Non-Res/Recreation/Convention-Exhibit Ctr
        </option>
        <option value="Non-Res/Recreation/Athletic Facility">
          Non-Res/Recreation/Athletic Facility
        </option>
        <option value="Non-Res/Recreation/Swimming Pool">
          Non-Res/Recreation/Swimming Pool
        </option>
        <option value="Non-Res/Recreation/Social Club">
          Non-Res/Recreation/Social Club
        </option>
        <option value="Non-Res/Recreation/Beach-Marina Facility">
          Non-Res/Recreation/Beach-Marina Facility
        </option>
        <option value="Non-Res/Recreation/Bowling Alley">
          Non-Res/Recreation/Bowling Alley
        </option>
        <option value="Non-Res/Recreation/Misc. Recreation">
          Non-Res/Recreation/Misc. Recreation
        </option>
        <option value="Non-Res/Recreation/Indoor Arena">
          Non-Res/Recreation/Indoor Arena
        </option>
        <option value="Non-Res/Pub Bldgs/Captl-Crt hs-City Hall">
          Non-Res/Pub Bldgs/Captl-Crt hs-City Hall
        </option>
        <option value="Non-Res/Pub Bldgs/Post Office">
          Non-Res/Pub Bldgs/Post Office
        </option>
        <option value="Non-Res/Pub Bldgs/Fire-Police Station">
          Non-Res/Pub Bldgs/Fire-Police Station
        </option>
        <option value="Non-Res/Pub Bldgs/Prison-Jail">
          Non-Res/Pub Bldgs/Prison-Jail
        </option>
        <option value="Non-Res/Medical/Hospital">
          Non-Res/Medical/Hospital
        </option>
        <option value="Non-Res/Medical/Hospital">
          Non-Res/Medical/Hospital
        </option>
        <option value="Non-Res/Medical/Clinic-Medical Office">
          Non-Res/Medical/Clinic-Medical Office
        </option>
        <option value="Non-Res/Medical/Nursing-Medical Office">
          Non-Res/Medical/Nursing-Medical Office
        </option>
        <option value="Non-Res/Laboratories">
          Non-Res/Laboratories
        </option>
        <option value="Non-Res/Hotels-Motels">
          Non-Res/Hotels-Motels
        </option>
        <option value="Non-Res/Dormitories">
          Non-Res/Dormitories
        </option>
        <option value="Non-Res/Federal Facility/Military Facility">
          Non-Res/Fenderal Facility/Military Facility
        </option>
        <option value="Non-Res/Federal Facility/Space Facility">
          Non-Res/Fenderal Facility/Space Facility
        </option>
        <option value="Non-Res/Animal-Plant-Fish Facility">
          Non-Res/Animal-Plant-Fish Facility
        </option>
        <option value="Non-Res/Communications Building">
          Non-Res/Communications Building
        </option>
        <option value="Non-Res/Religous/Worship Facility">
          Non-Res/Religous/Worship Facility
        </option>
        <option value="Non-Res/Religous/Funeral-Internment">
          Non-Res/Religous/Funeral-Internment
        </option>
        <option value="Non-Res/Religous/other">
          Non-Res/Religous/other
        </option>
        <option value="Civil & Utility Buildings">
          Civil & Utility Buildings
        </option>
      </d-select>
    </d-field>
    <d-field label="City">
      <d-input v-model="computedProject.city" />
    </d-field>
    <d-field label="State/Province">
      <d-input v-model="computedProject.stateProvince" />
    </d-field>
    <d-field label="Country">
      <d-input v-model="computedProject.country" />
    </d-field>
    <d-field label="Standards">
      <d-select v-model="computedProject.standards" expanded>
        <option value="AWI Standards, Current Edition">
          AWI Standards: Current Edition
        </option>
        <option value="AWS, Edition 2">
          Architectural Woodwork Standards: Edition 2 [2019]
        </option>
        <option value="AWS, Edition 1">
          Architectural Woodwork Standards: Edition 1 [2009]
        </option>
      </d-select>
    </d-field>
    <d-field label="Project Bid Date">
      <d-datepicker v-model="computedProject.projectBidDate" expanded placeholder="Click to select a date..." icon="calendar" editable />
    </d-field>
    <d-field label="Estimated Start of Fabrication">
      <d-datepicker v-model="computedProject.estimatedShopDrawingStartDate" expanded placeholder="Click to select a date..." icon="calendar" editable />
    </d-field>
    <d-field label="Estimated Completion Date">
      <d-datepicker v-model="computedProject.estimatedCompletionDate" expanded placeholder="Click to select a date..." icon="calendar" editable />
    </d-field>
    <d-field label="Estimated Commencement Date">
      <d-datepicker v-model="computedProject.estimatedCommencementDate" expanded placeholder="Click to select a date..." icon="calendar" editable />
    </d-field>
  </div>
</template>

<script>
  export default {
    props: {
      project: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      computedProject: {
        get() {
          return this.project;
        },
        set(value) {
          this.$emit('update:project', value);
        },
      },

      computedYearCompleted: {
        get() {
          return this.project.yearCompleted;
        },
        set(value) {
          this.computedProject.yearCompleted = Number.parseInt(value, 10);
        },
      },
    },
  };
</script>